import { action } from 'satcheljs';
import InboxPlusPivotViewState from '../store/schema/InboxPlusPivotViewState';
import { addDatapointConfig } from 'owa-analytics-actions';
import getInboxPlusDatapointCustomData from '../selectors/getInboxPlusDatapointCustomData';
import { isFeatureEnabled } from 'owa-feature-flags';

// Populate the inbox plus store from user session data on OWA first load
export const bootstrapInboxPlusPivots = action(
    'BOOTSTRAP_INBOX_PLUS_PIVOTS',
    (
        pivotsToSet: InboxPlusPivotViewState[],
        isFirstRunExperience: boolean,
        fixInboxPlusState: boolean
    ) =>
        addDatapointConfig(
            {
                name: 'TnS_BootstrapInboxPlus',
                customData: getInboxPlusDatapointCustomData(pivotsToSet, {
                    isFirstRunExperience: isFirstRunExperience,
                    fixInboxPlusState: fixInboxPlusState,
                    isEasyOnExperiment: isFeatureEnabled('tri-inboxPlusEasyOnFocusedExclusion'),
                    isEasyOnFocusedInclusionExperiment: isFeatureEnabled(
                        'tri-inboxPlusEasyOnFocusedInclusion'
                    ),
                }),
                options: {
                    isCore: true,
                },
            },
            {
                pivotsToSet,
                isFirstRunExperience,
                fixInboxPlusState,
            }
        )
);

export const onPivotEnableDisableDialogSave = action(
    'ON_PIVOT_ENABLE_DISABLE_DIALOG_SAVE',
    (pivotsToSet: InboxPlusPivotViewState[], isFromEasyOn: boolean) =>
        addDatapointConfig(
            {
                name: 'TnS_SaveInboxPlusDialog',
                customData: getInboxPlusDatapointCustomData(pivotsToSet, {
                    isFromEasyOn: isFromEasyOn,
                    isEasyOnExperiment: isFeatureEnabled('tri-inboxPlusEasyOnFocusedExclusion'),
                    isEasyOnFocusedInclusionExperiment: isFeatureEnabled(
                        'tri-inboxPlusEasyOnFocusedInclusion'
                    ),
                }),
                options: {
                    isCore: true,
                },
            },
            { pivotsToSet }
        )
);

export const logInboxPlusExperimentData = action('LOG_INBOX_PLUS_EXPERIMENT_DATA');

export const onEasyOnTryNowClicked = action(
    'ON_INBOX_PLUS_TRY_NOW_CLICKED',
    (pivotsToSet: InboxPlusPivotViewState[]) =>
        addDatapointConfig(
            {
                name: 'InboxEasyOnTryNowClicked',
                customData: {
                    isEasyOnFocusedInclusionExperiment: isFeatureEnabled(
                        'tri-inboxPlusEasyOnFocusedInclusion'
                    ),
                },
                options: {
                    isCore: true,
                },
            },
            { pivotsToSet }
        )
);
